import { getCookie, removeCookie, setCookie } from '#pplx/frontend/cookies/provider.js';
/**
 * Shared handoff between marketing signup and the Ask app's post-auth binder.
 * Comet P2P uses the same `dub_id` cookie, so that cookie alone cannot select
 * this affiliate program.
 */
export const PPLX_COMPUTER_AFFILIATE_PENDING_COOKIE = 'pplx.computer-affiliate-pending';
export const PPLX_COMPUTER_AFFILIATE_ANONYMOUS_MARKER = 'anonymous';
export const PPLX_COMPUTER_AFFILIATE_EXISTING_USER_MARKER = 'existing-user';
export const PPLX_COMPUTER_AFFILIATE_EXISTING_USER_MARKER_PREFIX = 'existing-user:';
const PPLX_COMPUTER_AFFILIATE_EXISTING_USER_STORAGE_KEY = 'pplx.computer-affiliate-existing-user';
export const getComputerAffiliateExistingUser = () => {
    const marker = getCookie(PPLX_COMPUTER_AFFILIATE_PENDING_COOKIE);
    if (marker?.startsWith(PPLX_COMPUTER_AFFILIATE_EXISTING_USER_MARKER_PREFIX)) {
        return marker.slice(PPLX_COMPUTER_AFFILIATE_EXISTING_USER_MARKER_PREFIX.length) || null;
    }
    // Retain compatibility with pending signups written before the cross-tab handoff.
    try {
        return window.sessionStorage.getItem(PPLX_COMPUTER_AFFILIATE_EXISTING_USER_STORAGE_KEY);
    }
    catch {
        return null;
    }
};
export const setComputerAffiliateExistingUser = (userId) => {
    try {
        window.sessionStorage.setItem(PPLX_COMPUTER_AFFILIATE_EXISTING_USER_STORAGE_KEY, userId);
        return true;
    }
    catch {
        return false;
    }
};
export const clearComputerAffiliateExistingUser = () => {
    try {
        window.sessionStorage.removeItem(PPLX_COMPUTER_AFFILIATE_EXISTING_USER_STORAGE_KEY);
    }
    catch {
        // A disabled session store already has the desired empty state.
    }
};
export const clearPendingComputerAffiliateBind = () => {
    removeCookie(PPLX_COMPUTER_AFFILIATE_PENDING_COOKIE);
    clearComputerAffiliateExistingUser();
};
export const getPendingComputerAffiliateBind = () => {
    const marker = getCookie(PPLX_COMPUTER_AFFILIATE_PENDING_COOKIE);
    // Session storage does not expire with the cookie. Do not retain an abandoned
    // signup's prior account after its pending marker has expired.
    if (!marker)
        clearComputerAffiliateExistingUser();
    return marker?.startsWith(PPLX_COMPUTER_AFFILIATE_EXISTING_USER_MARKER_PREFIX)
        ? PPLX_COMPUTER_AFFILIATE_EXISTING_USER_MARKER
        : marker;
};
export const setPendingComputerAffiliateBind = ({ existingUserId, expires, }) => {
    clearPendingComputerAffiliateBind();
    if (existingUserId)
        setComputerAffiliateExistingUser(existingUserId);
    setCookie(PPLX_COMPUTER_AFFILIATE_PENDING_COOKIE, existingUserId
        ? `${PPLX_COMPUTER_AFFILIATE_EXISTING_USER_MARKER_PREFIX}${existingUserId}`
        : PPLX_COMPUTER_AFFILIATE_ANONYMOUS_MARKER, { expires });
};
//# sourceMappingURL=storage.js.map